// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3LHl_","validationTips":"StatementDescriptor_validationTips__2xbCX"};